import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { IRoute } from 'interfaces';
import { commonHelpers } from 'helpers';
import ModalComponent from 'components/ModalComponent';
import { getLazyName } from 'helpers/i18n';

const { getExternalPath } = commonHelpers;

const ModalItem: React.FC<{ item: IRoute }> = ({ item }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button type="link" onClick={() => setShowModal(true)}>
        {item.icon && <item.icon className="app-icon" />}
        <span>{getLazyName(item.name)}</span>
      </Button>
      <ModalComponent
        component={item.component}
        iFrameSrc={item.iFrameSrc}
        showModal={showModal}
        setShowModal={setShowModal}
        isSuspense
      />
    </>
  );
};

const MenuItemContent: React.FC<{ item: IRoute }> = ({ item }) => {
  const currentLocation = window?.location?.pathname;
  const routeName = getLazyName(item.name);
  return item.redirectOutside ? (
    <a
      href={getExternalPath(item)}
      target="_blank"
      rel="noopener noreferrer"
      title={routeName}
    >
      {item.icon && <item.icon className="app-icon" />}
      <span>{routeName}</span>
    </a>
  ) : item.isModalItem ? (
    <ModalItem item={item} />
  ) : (
    <Link
      to={item.path}
      title={routeName}
      onClick={e => {
        if (currentLocation === item.path) e.preventDefault();
      }}
    >
      {item.icon && <item.icon className="app-icon" />}
      <span>{routeName}</span>
    </Link>
  );
};

export default MenuItemContent;
